import * as React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';

import { SectionInfoNarrow } from '../layout/SectionInfoNarrow';
import { SectionNewDevelopment } from '../layout/SectionNewDevelopment';
import { SectionContact } from '../layout/SectionContact';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { PageContentType } from '../../../server/global/enum';

//GraphQL
import { useQuery } from '@apollo/client';
import {
  Query,
  QueryGetPageContentInputArgs,
} from '../../../client/types/generated/types';
import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';

const PortalBuyDevStyle = styled.div`
  margin-top: 150px;
`;

type GetPageItem = Pick<Query, 'getNdPageContent'>;
type GetPageItemVariables = QueryGetPageContentInputArgs;

const PortalBuyDevelopment: React.FC = () => {
  const params = useParams<{ urltag: string }>();

  const { data, loading } = useQuery<GetPageItem, QueryGetPageContentInputArgs>(CONTENT_ITEM,
    {
      skip: !params.urltag,
      fetchPolicy: 'network-only',
      variables: { input: { urltag: params.urltag, type: PageContentType.BUY }, },
    }
  );

  return (
    <>
      <Seo
        title={`Kjøpe eiendom - PrivatMegleren - ${data?.getNdPageContent?.seo?.title}`}
        image={(data?.getNdPageContent?.seo?.image ? data?.getNdPageContent?.seo?.image : undefined)}
        description={(data?.getNdPageContent?.seo?.text ? data?.getNdPageContent?.seo?.text : undefined)}
      />
      <Page>
        <PortalBuyDevStyle>
          <SectionInfoNarrow
            title={data?.getNdPageContent?.title}
            info={data?.getNdPageContent?.text}
            hidebackground
          />
          <SectionNewDevelopment showProperties={true} limit={9} />
          {data?.getNdPageContent?.config?.showSubpageContact ? <SectionContact /> : null}
        </PortalBuyDevStyle>
      </Page>
    </>
  );
};

export default PortalBuyDevelopment;
